<wk-icon-pencil-sprite-pds3 />
<div (click)="promptForEdition(selectedDashboard)" class="wk-srd__button">
    <icon-pds3 name="wk-icon-pencil" class="icon-pencil wk-srd__button-icon" />
    <div class="wk-srd__button-title">{{ "Settings.EditDashboard" | translate }}</div>
</div>
